import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

/* eslint-disable */
const Svg = () => (
  // eslint-disable-next-line
  <svg 
    viewBox="0 0 1024 1024" 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    p-id="7169" 
    width="16" 
    height="16"
  >
    <path d="M921.1 61.4H102.9c-45.5 0-82.4 36.9-82.4 82.4v736.3c0 45.5 36.9 82.4 82.4 82.4h818.2c45.5 0 82.4-36.9 82.4-82.4V143.8c0-45.5-36.9-82.4-82.4-82.4zM102.4 184.8c0-22.9 18.6-41.4 41.4-41.4h736.3c22.9 0 41.4 18.6 41.4 41.4v81.4H102.4v-81.4zM880 880.6H143.8c-22.9 0-41.4-18.6-41.4-41.4v-491h819.2l-0.1 491c0 22.9-18.6 41.4-41.5 41.4z" p-id="7170"></path>
    <path d="M599 463.6c-19.5-11.3-44.7-4.5-56 15L410 709.2c-11.3 19.5-4.5 44.7 15 56 19.5 11.3 44.7 4.5 56-15l133-230.6c11.3-19.5 4.5-44.7-15-56zM332.6 469.6c-15.9-15.9-42-15.9-57.9 0L158.9 585.4c-15.9 15.9-15.9 42 0 57.9l115.9 115.9c15.9 15.9 42 15.9 57.9 0 15.9-15.9 15.9-42 0-57.9l-86.9-86.9 86.9-86.9c15.9-15.9 15.9-42-0.1-57.9zM749.3 469.6c-15.9-15.9-42-15.9-57.9 0-15.9 15.9-15.9 42 0 57.9l86.9 86.9-86.9 86.9c-15.9 15.9-15.9 42 0 57.9 15.9 15.9 42 15.9 57.9 0l115.9-115.9c15.9-15.9 15.9-42 0-57.9L749.3 469.6z" p-id="7171"></path>
  </svg>
)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent
